import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(theme => ({
  text: {
    transform: 'scale(1, 1)'
  }
}));

export const OverviewChartLoading = ({ height = 70 }) => {
  const classes = useStyles();

  return (
    <Skeleton
      width="100%"
      height={height}
      classes={useMemo(() => ({ text: classes.text }), [classes.text])}
    />
  );
};

OverviewChartLoading.propTypes = {
  height: PropTypes.number
};

export default OverviewChartLoading;
